import * as React from 'react';
import { UIText1, IconChevronRight16, IconProductKey24, IconProfile24 } from '@cian/ui-kit';
import iconChange24 from './assets/IconChange24.svg';

import * as styles from './styles.css';

interface ICPDModalContentProps {
  onSaleClick: () => void;
  onSaleToBuyClick: () => void;
  onRentClick: () => void;
  onOtherClick: () => void;
}

export const CPDModalContent: React.FC<ICPDModalContentProps> = ({
  onSaleClick,
  onSaleToBuyClick,
  onRentClick,
  onOtherClick,
}) => {
  return (
    <div className={styles['wrapper']}>
      <ul>
        <li className={styles['item']} onClick={onSaleClick}>
          <div className={styles['item-title']}>
            <div className={styles['item-icon']}>
              <IconProductKey24 color="white_100" />
            </div>
            <UIText1 color="black_100">Продать квартиру</UIText1>
          </div>

          <IconChevronRight16 color="gray60_100" />
        </li>

        <li className={styles['item']} onClick={onSaleToBuyClick}>
          <div className={styles['item-title']}>
            <div className={styles['item-icon']}>
              <img src={iconChange24} />
            </div>
            <UIText1 color="black_100">Продать квартиру и купить новое жильё</UIText1>
          </div>

          <IconChevronRight16 color="gray60_100" />
        </li>

        <li className={styles['item']} onClick={onRentClick}>
          <div className={styles['item-title']}>
            <div className={styles['item-icon']}>
              <IconProfile24 color="white_100" />
            </div>
            <UIText1 color="black_100">Сдать квартиру</UIText1>
          </div>

          <IconChevronRight16 color="gray60_100" />
        </li>

        <li className={styles['item']} onClick={onOtherClick}>
          <div className={styles['item-title']}>
            <div className={styles['item-icon']}>
              <IconProfile24 color="white_100" />
            </div>
            <UIText1 color="black_100">Другой запрос</UIText1>
          </div>

          <IconChevronRight16 color="gray60_100" />
        </li>
      </ul>
    </div>
  );
};
